import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0942cab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  value: "default"
}
const _hoisted_5 = {
  key: 1,
  class: "ph-error"
}

import { PreHangOption } from '@/types/preHang'
    import { PropType, ref, watch } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangSelect',
  props: {
        fieldName: { type: String, required: true },
        label: { type: String, required: false, default: '' },
        options: { type: Array as PropType<PreHangOption[]>, required: true },
        value: { type: Object as PropType<PreHangOption | null>, required: false },
        hasRequiredError: { type: Boolean, required: false, default: false },
        isDisabled: { type: Boolean, required: false, default: false },
        allowNull: { type: Boolean, required: false, default: false },
        nullValue: { type: String, required: false, default: 'None' }
    },
  emits: ['select'],
  setup(__props, { emit: emits }) {

const props = __props

    

    
    const selection = ref<string | number>('')

    watch(selection, (current, old) => {
        if(current && current !== 'default') {
            if(parseInt(current as string) !== props.value?.id) {
                const selectedOption = props.options?.find(o => o.id === parseInt(current as string))
                emits("select", selectedOption, props.fieldName)
            }
        }
    })

    watch(() => props.value, (current, old) => {
        if(current) {
            selection.value = current?.id.toString() as string
        } else {
            selection.value = 'default'
        }
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (props.options?.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form-group text-left", {'ph-error': props.hasRequiredError}])
      }, [
        (props.label)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: 'ph_' + props.fieldName
            }, _toDisplayString(props.label) + ":", 9, _hoisted_1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selection).value = $event)),
          id: 'ph_' + props.fieldName,
          class: _normalizeClass(["form-select form-select-sm", { 'mb-3': !props.hasRequiredError }]),
          disabled: props.isDisabled
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.id,
              value: option.id
            }, _toDisplayString(option.name), 9, _hoisted_3))
          }), 128)),
          (props.value === null)
            ? (_openBlock(), _createElementBlock("option", _hoisted_4, _toDisplayString(props.nullValue), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2), [
          [_vModelSelect, selection.value]
        ]),
        (props.hasRequiredError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Selection required."))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})